import { pattern, SchemaPath } from '@angular/forms/signals';

export const PHONE_NUMBER_PATTERN = /^\+?[0-9]{1,4}[\s.-]?(?:[0-9]{1,3}[\s.-]?){1,4}[0-9]{1,4}$/;

/** Signal Forms rule: optional phone number in international or local format. Error kind: `pattern`. */
export function phoneNumber(path: SchemaPath<string>, options: { message?: string } = {}): void {
  pattern(path, PHONE_NUMBER_PATTERN, { message: options.message });
}
